import React, { useState, Dispatch, SetStateAction } from 'react'
import Button, { ButtonProps } from '../button/button'
import Icon from '../icon/icon'
import { useTranslation } from 'react-i18next'
import CustomDialog from '../custom-dialog/custom-dialog'
import Checkbox from '../checkbox/checkbox'
import { Grid } from '@material-ui/core'
import { ColumnToggle } from '../admin-table/admin-table'
import { SpacingProps } from 'src/hooks/spacing'

const overridePosition = {
  position: 'absolute',
  top: 25,
  right: 50,
  bottom: 'auto',
  left: 'auto',
  width: 300
}

export type TableColumns = {
  key: string
  title?: React.ReactNode
  getValue: (t: any) => React.ReactNode
  hidden?: boolean
  widthClassName?: string
  noWrapTitle?: boolean
  noPadding?: boolean
  sort?: boolean
  hideHeaderDivider?: boolean
  hideCellDivider?: boolean
  columnToggle?: ColumnToggle
  accessor: string
  Header: () => string
}

interface TableColumnButtonProps extends Omit<ButtonProps, 'icon' | 'iconClassname'>, SpacingProps {
  cols: TableColumns[]
  setCols: Dispatch<SetStateAction<any[]>>
}

export const TableColumnButton: React.FC<TableColumnButtonProps> = ({ cols, spacing, setCols }) => {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const handleChange = (key: string, state: boolean) => {
    const updatedCols = cols.map(col => {
      if ((col?.accessor || col.key) === key)
        return { ...col, columnToggle: { ...col.columnToggle, checked: state } }
      return col
    })
    setCols(updatedCols)
    setIsDialogOpen(false)
  }

  const sortedCols = cols
    .filter(c => c.columnToggle)
    .map((col, index) => ({
      ...col,
      columnToggle: { ...col.columnToggle, index: col.columnToggle?.index || index }
    }))
    .sort((a, z) => a.columnToggle?.index - z.columnToggle?.index)

  return (
    <>
      <Button onClick={() => setIsDialogOpen(true)} level="tertiary" spacing={spacing}>
        <Icon name="sm-columns" spacing={{ margins: { xs: 'right' } }} />
        {t('columns')}
      </Button>
      <CustomDialog
        title={''}
        open={isDialogOpen}
        hideX
        content={
          <Grid container direction="column">
            {sortedCols.map(col => {
              const { columnToggle } = col

              return (
                <Checkbox
                  key={col?.accessor || col.key}
                  disabled={(columnToggle as any)?.disabled}
                  label={col?.Header?.() || (col.title as string) || ''}
                  onChange={(state: boolean) => handleChange(col?.accessor || col.key, state)}
                  initialState={(columnToggle as any).checked}
                />
              )
            })}
          </Grid>
        }
        overridePosition={overridePosition}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  )
}
